<template>
  <ValidationProvider :rules="rules" v-slot="{ errors }" mode="passive">
    <div>
      <label class="body-small" v-if="label">{{ label }}</label>
      <v-text-field
        v-model="input"
        :dense="dense"
        ref="input"
        :class="label ? 'mt-1' : ''"
        @keypress="isNumber($event)"
        v-bind="$attrs"
        :value="input"
        v-mask="'(###) ###-####'"
        @keydown.enter.prevent="$emit('enter')"
        outlined
        :error-messages="errors"
        @input="$emit('input', input)"
      >
        <template v-slot:append>
          <v-tooltip bottom v-if="help">
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" class="" x-small>
                <v-icon>mdi-help-circle-outline</v-icon>
              </v-btn>
            </template>
            <span>{{ help }}</span>
          </v-tooltip>
        </template>
      </v-text-field>
    </div>
  </ValidationProvider>
</template>

<script>
import {getRules, inputDense} from "../../../assets/utils/common.utils.js";

export default {
  inheritAttrs: false,
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    help: {
      type: String,
      default: "",
    },
    dense: {
      type: Boolean,
      default: inputDense,
    },
    outlined: {
      type: Boolean,
      default: true,
    },
    rules: {
      type: String,
      default: "",
    },
    customRules: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      input: "",
    };
  },
  computed: {
    getRules() {
      let { customRules, rules } = this;
      if (customRules.length > 0) return customRules;
      return getRules(rules);
    },
  },
  watch: {
    value(val) {
      this.input = val;
    },
  },
  methods: {
    isNumber: function (evt) {
      let val = this.input || "";
      let text = val.replace(/^\D+/g, "");
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (!text && charCode == 49) {
        evt.preventDefault();
        return;
      }
      return true;
    },
  },
  mounted() {
    this.input = this.value;
  },
};
</script>
